import { useEffect, useState, type ReactNode } from 'react';
import Toast from 'react-bootstrap/Toast';

/**
 * Port of `commonComponents/responseToast.jsx` — the 5-second auto-dismissing toast used
 * for save/submit/copy confirmations.
 */
export function ResponseToast({
  responseMessage,
  hide,
}: {
  /**
   * A node, not a string: NavBar passes plain text, but mainMenu.jsx passes a `<div>` that
   * appends a warning icon and a second sentence after a successful save (jsx:2798-2819).
   */
  responseMessage: ReactNode;
  hide: () => void;
}): JSX.Element {
  // The original kept a `toast` flag in state but never read it — the toast is unmounted
  // by the parent instead. The state write is dropped; the timer that accompanied it is
  // not, because the parent's `hide()` is what actually removes the component.
  const [, setDismissed] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDismissed(true);
      hide();
    }, 5000);
    // The original never cleared this timeout, so unmounting before it fired left it to
    // call setState on a dead component. Clearing it changes no visible behavior and
    // removes the stray call.
    return () => clearTimeout(timer);
  }, [hide]);

  return (
    <div
      style={{
        position: 'absolute',
        top: 20,
        right: 10,
        zIndex: 9999,
        float: 'right',
      }}
    >
      <Toast
        className="response_Toast"
        style={{
          backgroundColor: '#0e0d0d',
          color: '#ececec',
          width: 'fit-content',
        }}
        onClose={() => {
          setDismissed(true);
          hide();
        }}
      >
        <Toast.Body>
          <div className="" style={{ fontSize: '12px' }}>
            {responseMessage}
          </div>
        </Toast.Body>
      </Toast>
    </div>
  );
}
